import { render } from "./_event-specifics.vue?vue&type=template&id=7099d402&scoped=true&lang=pug"
import script from "./_event-specifics.vue?vue&type=script&lang=js"
export * from "./_event-specifics.vue?vue&type=script&lang=js"

import "./_event-specifics.vue?vue&type=style&index=0&id=7099d402&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7099d402"]])

export default __exports__